"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const core_1 = require("@material-ui/core");
const download_svg_1 = tslib_1.__importDefault(require("../../../../../images/icons/download.svg"));
const graph_component_1 = tslib_1.__importDefault(require("../../../../../layouts/graph-component"));
const warning_svg_1 = tslib_1.__importDefault(require("../../../../../images/icons/warning.svg"));
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
const enum_1 = require("src/app/auto-ml/utils/enum");
function DataTransformationRCAMSStep2(props) {
    const { graphPath, yamlFile, method } = props;
    const styleLocal = style_1.default();
    const handleDownloadYamlFile = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(yamlFile);
            if (!response.ok)
                throw new Error("Network response was not ok");
            const blob = yield response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "domain_knowledge.yaml"; // Set file name
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }
        catch (error) {
            console.error("Download failed:", error);
        }
    });
    return (react_1.default.createElement(core_1.Grid, { container: true, justifyContent: "center", style: { marginTop: "20px" } },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, sm: 2, md: 8, lg: 8 },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, component: "span", style: { padding: "20px 0px", display: "flex" } }, "Click to download the YAML file associated with the generated graph.")),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 8, lg: 8, style: { display: 'flex', justifyContent: 'flex-end' } },
            react_1.default.createElement(core_1.Button, { variant: "contained", onClick: handleDownloadYamlFile, startIcon: react_1.default.createElement("img", { src: download_svg_1.default, style: { width: 20, height: 20 } }), disabled: method == enum_1.DomainKnowledgeType.NONE, className: styleLocal.downloadYamlBtn }, "download yaml")),
        graphPath ?
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 8, lg: 8, backgroundcolor: "white" },
                react_1.default.createElement(core_1.Box, { border: 1, className: styleLocal.graphContainer },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", align: "center", gutterBottom: true }, "Casual Graph with Arrow Adjustment"),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, className: styleLocal.graph },
                        react_1.default.createElement(graph_component_1.default, { csvPath: graphPath }))))
            :
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 8, lg: 8, className: styleLocal.graphWarning },
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "column" // Ensure elements are stacked vertically
                        , justifyContent: "center", alignItems: "center" },
                        react_1.default.createElement(core_1.Grid, { item: true, className: styleLocal.warningIconContainer },
                            react_1.default.createElement("img", { src: warning_svg_1.default, className: styleLocal.warningIcon })),
                        react_1.default.createElement(core_1.Typography, { style: { marginTop: '8px' } }, "Graph generation was not successful. Please check your data and try again!")))));
}
exports.DataTransformationRCAMSStep2 = DataTransformationRCAMSStep2;
//# sourceMappingURL=data-transformation-rca-ms-step2.js.map